import { Action } from '@ngrx/store';
import { Performance, PerformanceRequestPayload, PerformanceRequestCSVPayload } from './performance.models';
import { DatesIntervalRequest, DatesInterval } from '../../global/interfaces';

export enum ActionTypes {
  LOAD_PERFORMANCE_DATA          = '[Performance] Load Performance Data Action',
  LOAD_PERFORMANCE_DATA_SUCCESS  = '[Performance] Load Performance Data Success Action',
  LOAD_PERFORMANCE_DATA_FAILED   = '[Performance] Load Performance Data Failed Action',

  LOAD_PERFORMANCE_DATES         = '[Performance] Load Performance Dates Action',
  LOAD_PERFORMANCE_DATES_SUCCESS = '[Performance] Load Performance Dates Success Action',
  LOAD_PERFORMANCE_DATES_FAILED  = '[Performance] Load Performance Dates Failed Action',

  SET_PERFORMANCE_TYPE_FILTER    = '[Performance] Set Performance Type Filter Action',
  SET_PERFORMANCE_OPTION_FILTER  = '[Performance] Set Performance Option Filter Action',
  SET_PERFORMANCE_FUND_FILTER    = '[Performance] Set Performance Fund Filter Action',
  SET_PERFORMANCE_YEAR_FILTER    = '[Performance] Set Performance Year Filter Action',
  SET_PERFORMANCE_MONTH_FILTER   = '[Performance] Set Performance Month Filter Action',

  PERFORMANCE_FILE_DOWNLOAD      = '[Performance] Download Performance Report',

  RESET_PERFORMANCE_FILTER       = '[Performance] Reset Performance Filter Action',
  RESET_PERFORMANCE_DATA         = '[Performance] Reset Performance Data Action'
}

export class LoadPerformanceDatesAction implements Action {
  readonly type = ActionTypes.LOAD_PERFORMANCE_DATES;

  public constructor(public payload: DatesIntervalRequest) {
  }
}

export class LoadPerformanceDatesSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_PERFORMANCE_DATES_SUCCESS;

  public constructor(public payload: DatesInterval) {
  }
}

export class LoadPerformanceDatesFailedAction implements Action {
  readonly type = ActionTypes.LOAD_PERFORMANCE_DATES_FAILED;

  public constructor(public payload: any) {
  }
}

export class LoadPerformanceDataAction implements Action {
  readonly type = ActionTypes.LOAD_PERFORMANCE_DATA;

  public constructor(public payload: any) {
  }
}

export class LoadPerformanceDataSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_PERFORMANCE_DATA_SUCCESS;

  public constructor(public payload: Performance) {
  }
}

export class LoadPerformanceDataFailedAction implements Action {
  readonly type = ActionTypes.LOAD_PERFORMANCE_DATA_FAILED;

  public constructor(public payload: any) {
  }
}

export class SetPerformanceTypeFilterAction implements Action {
  readonly type = ActionTypes.SET_PERFORMANCE_TYPE_FILTER;
}

export class SetPerformanceOptionFilterAction implements Action {
  readonly type = ActionTypes.SET_PERFORMANCE_OPTION_FILTER;

  public constructor(public payload: 'total' | 'excess') {
  }
}

export class SetPerformanceFundFilterAction implements Action {
  readonly type = ActionTypes.SET_PERFORMANCE_FUND_FILTER;

  public constructor(public payload: string) {
  }
}

export class SetPerformanceYearFilterAction implements Action {
  readonly type = ActionTypes.SET_PERFORMANCE_YEAR_FILTER;

  public constructor(public payload: number) {
  }
}

export class SetPerformanceMonthFilterAction implements Action {
  readonly type = ActionTypes.SET_PERFORMANCE_MONTH_FILTER;

  public constructor(public payload: number) {
  }
}

export class PerformanceFileDownloadAction implements Action {
  readonly type = ActionTypes.PERFORMANCE_FILE_DOWNLOAD;

  public constructor(public payload: PerformanceRequestCSVPayload) {
  }
}

export class ResetPerformanceFilterAction implements Action {
  readonly type = ActionTypes.RESET_PERFORMANCE_FILTER;
}

export class ResetPerformanceDataAction implements Action {
  readonly type = ActionTypes.RESET_PERFORMANCE_DATA;
}

export type Actions =
  LoadPerformanceDataAction |
  LoadPerformanceDataSuccessAction |
  LoadPerformanceDataFailedAction |
  LoadPerformanceDatesAction |
  LoadPerformanceDatesSuccessAction |
  LoadPerformanceDatesFailedAction |
  SetPerformanceTypeFilterAction |
  SetPerformanceOptionFilterAction |
  SetPerformanceFundFilterAction |
  SetPerformanceYearFilterAction |
  SetPerformanceMonthFilterAction |
  PerformanceFileDownloadAction |
  ResetPerformanceFilterAction |
  ResetPerformanceDataAction;
